export default __webpack_public_path__ + "static/media/mail.2b4771a7.svg";